import SubcontractorsIndex from '@/modules/subcontractors/pages/SubcontractorsIndex';
import { RoutesMounter } from '../../../types';

export const mountEmployeeSubcontractorsRoutes: RoutesMounter = ({ path }) => [
  {
    path,
    children: [{ index: true, element: <SubcontractorsIndex /> }],
  },
];
